export enum CometMethod {
  subscribe = 'comet_subscribe',
  unsubscribe = 'comet_unsubscribe',
}
